import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CaseType, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { Observable } from 'rxjs';
import { CLMI_APPLY_TRANSLATIONS } from '../../constants/header.constants';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class CaseTypesService {
    constructor(
        private http: HttpClient,
        private config: ConfigService,
    ) {}

    getAll(
        isActive: boolean,
        entityType?: SystemEntity,
        entityId?: string,
    ): Observable<CaseType[]> {
        const baseUrl = `${this.config.getConfiguration().API_BASE}/casetype`;

        const isOpportunity = entityType === SystemEntity.Opportunity;

        const queryParams = isOpportunity
            ? [`entityType=${entityType}`]
            : [
                  isActive ? 'isActive=true' : '',
                  entityType ? `entityType=${entityType}` : '',
              ].filter((param) => param);

        if (entityId) {
            queryParams.push(`entityId=${entityId}`);
        }

        const queryString = queryParams.length
            ? `?${queryParams.join('&')}`
            : '';

        const url = `${baseUrl}${queryString}`;

        return this.http.get<CaseType[]>(url, {
            headers: {
                [CLMI_APPLY_TRANSLATIONS]: 'true',
            },
        });
    }
}
